import { render, staticRenderFns } from "./Drugstore.vue?vue&type=template&id=2c7f7b33&scoped=true&lang=pug&"
import script from "./Drugstore.vue?vue&type=script&lang=js&"
export * from "./Drugstore.vue?vue&type=script&lang=js&"
import style0 from "./Drugstore.vue?vue&type=style&index=0&id=2c7f7b33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f7b33",
  null
  
)

export default component.exports